import GoalSurveyType from "@/api/dataSource/api/Spirit/Entities/User/GoalSurveyType";
import moment from "moment";
import Vue from "vue";

Vue.filter('goalSurveyName', function (value: GoalSurveyType) {
    switch (value) {
        case GoalSurveyType.BeProductive: return "Быть продуктивнее";
        case GoalSurveyType.IncreaseSelfEsteemAssessment: return "Повысить самооценку";
        case GoalSurveyType.ImproveSleep: return "Улучшить сон";
        case GoalSurveyType.ReduceStress: return "Уменьшить стресс";
        case GoalSurveyType.PerformBreathingTechniques: return "Выполнять дыхательные техники";
        case GoalSurveyType.TuneInToThePositive: return "Настраиваться на позитив";
        default: return '';
    }
})

Vue.filter('goalSurveyImage', function (value: GoalSurveyType) {
    switch (value) {
        case GoalSurveyType.BeProductive: return "/assets/img/goal-survey/bulb.png";
        case GoalSurveyType.IncreaseSelfEsteemAssessment: return "/assets/img/goal-survey/flame.png";
        case GoalSurveyType.ImproveSleep: return "/assets/img/goal-survey/moon.png";
        case GoalSurveyType.ReduceStress: return "/assets/img/goal-survey/leaf.png";
        case GoalSurveyType.PerformBreathingTechniques: return "/assets/img/goal-survey/waves.png";
        case GoalSurveyType.TuneInToThePositive: return "/assets/img/goal-survey/lotus.png";
        default: return '';
    }
})
